import React from 'react';
import Grid from '@material-ui/core/Grid';

const container = {
    marginTop: 40,
};

export default function Inline(props) {
    if (props.margin) {
        return (
            <div style={container}>
                <Grid container item xs={12} spacing={props.spacing ? props.spacing : 2}>
                    {props.children}
                </Grid>
            </div>
        );
    } else {
        return (
            <Grid container item xs={12} spacing={props.spacing ? props.spacing : 2}>
                {props.children}
            </Grid>
        );
    }
}
